module.exports = __webpack_public_path__ + "img/reload.5c0e96ef.svg";